// @flow

/**
 * The type of (redux) action which sets the last-n for the conference.
 *
 * {
 *     type: SET_LAST_N,
 *     lastN: number
 * }
 */
export const SET_LAST_N = 'SET_LAST_N';
